import React from 'react';
import cn from 'bem-cn';

import PropmthubBalloonImage from '../../images/prompthub_balloon.png';

import { Icon, ImageWithFadeIn } from '../UI';

import './NoPromptsBanner.scss';

const b = cn('no-prompts-banner');

export const NoPromptsBanner: React.FC = () => {
    return (
        <div className={b()}>
            <ImageWithFadeIn src={PropmthubBalloonImage} alt="" className={b('image')} />
            <div className={b('icon')}>
                <Icon name="smile" size={28} />
            </div>
            <div className={b('text')}>У пользователя еще нет промптов</div>
        </div>
    );
};
